export default {
    LOAD_RELEASE_ACCESS(state, release_access) {
        state.items = release_access
    },

    LOAD_RELEASE_ACCESS_LIST(state, items) {
        state.list = items
    }
}